import { AcademicRegistration } from './academic-registration';
import { CheckoutFlow } from './checkout-flow';

export type RedirectableFlow = CheckoutFlow | AcademicRegistration;
